import React from "react";
import { View } from "react-native";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ValuationType } from "../../types/common.types";
import { FormFieldWrapper } from "./FormFieldWrapper";
import { WithoutFeedbackButton } from "../buttons/base/WithoutFeedbackButton";
import { Typography } from "../Typography";
import colors from "../../styles/colors";
import { useFormFieldErrors } from "../../hooks/form.hooks";

interface FormValuationTypeSelectionProps {
  name: string;
  label: string;
  isRequired?: boolean;
}

interface ValuationTypeOption {
  type: ValuationType;
  title: string;
  description: string;
}

export const FormValuationTypeSelection: React.FC<
  FormValuationTypeSelectionProps
> = ({ name, label, isRequired }) => {
  const { control } = useFormContext();
  const { t } = useTranslation();
  const { errorText } = useFormFieldErrors(name, label);

  const options: ValuationTypeOption[] = [
    {
      type: ValuationType.FullReport,
      title: t("propertyForm.valuationType.fullReport.title"),
      description: t("propertyForm.valuationType.fullReport.description"),
    },
    {
      type: ValuationType.PriceCheck,
      title: t("propertyForm.valuationType.priceCheck.title"),
      description: t("propertyForm.valuationType.priceCheck.description"),
    },
  ];

  return (
    <FormFieldWrapper label={label} error={errorText} isRequired={isRequired}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => (
          <View style={{ flexDirection: "row", gap: 15 }}>
            {options.map((option) => {
              const isSelected = value === option.type;
              return (
                <WithoutFeedbackButton
                  key={option.type}
                  onPress={() => onChange(option.type)}
                  style={{
                    flex: 1,
                    borderWidth: 2,
                    borderColor: isSelected ? colors.purple2 : colors.lightgrey,
                    borderRadius: 8,
                    padding: 16,
                    backgroundColor: isSelected
                      ? colors.purple2 + "10"
                      : "transparent",
                  }}
                >
                  <View>
                    <Typography
                      variant="h3"
                      textStyle={{
                        color: isSelected ? colors.purple2 : colors.black,
                        marginBottom: 8,
                        fontSize: 18,
                        fontWeight: "600",
                      }}
                    >
                      {option.title}
                    </Typography>
                    <Typography
                      variant="caption"
                      textStyle={{
                        color: isSelected ? colors.purple2 : colors.grey,
                        fontSize: 14,
                        lineHeight: 20,
                      }}
                    >
                      {option.description}
                    </Typography>
                  </View>
                </WithoutFeedbackButton>
              );
            })}
          </View>
        )}
      />
    </FormFieldWrapper>
  );
};
